import { useRef } from "react";
import styles from "./LazyImage.module.scss";
import clsx from "clsx";
interface PropsType {
  src: string;
}
const LazyImage = (props: PropsType) => {
  const { src } = props;
  const loadingDoms = useRef<HTMLDivElement>(null);
  return (
    <div className={clsx(styles["container"], styles["cover"])}>
      <img
        onLoad={() => {
          loadingDoms.current!.remove();
        }}
        src={src}
        alt=""
      />

      <div
        ref={loadingDoms}
        className={clsx(styles["loading"], "skeleton_loading")}
      ></div>
    </div>
  );
};

export default LazyImage;
